import { Controller } from '@hotwired/stimulus';

export default class extends Controller {
  static targets = ['viewport', 'prevButton', 'nextButton'];

  connect() {
    this.onScroll = () => this.updateArrows();
    this.onResize = () => {
      this.updateArrows();
      this.scrollActiveIntoView();
    };
    this.viewportTarget.addEventListener('scroll', this.onScroll, { passive: true });
    window.addEventListener('resize', this.onResize);
    this.updateArrows();
    this.scrollActiveIntoView();
  }

  disconnect() {
    this.viewportTarget.removeEventListener('scroll', this.onScroll);
    window.removeEventListener('resize', this.onResize);
  }

  scrollBack() {
    this.viewportTarget.scrollBy({ left: -this.scrollStep(), behavior: 'smooth' });
  }

  scrollForward() {
    this.viewportTarget.scrollBy({ left: this.scrollStep(), behavior: 'smooth' });
  }

  scrollStep() {
    return Math.max(160, Math.floor(this.viewportTarget.clientWidth * 0.72));
  }

  updateArrows() {
    const el = this.viewportTarget;
    const maxScroll = el.scrollWidth - el.clientWidth;
    const noOverflow = maxScroll <= 1;

    this.element.classList.toggle('hr-organization-nav--no-overflow', noOverflow);

    if (noOverflow) {
      this.setButtonHidden(this.prevButtonTarget, true);
      this.setButtonHidden(this.nextButtonTarget, true);
      return;
    }

    this.setButtonHidden(this.prevButtonTarget, el.scrollLeft <= 1);
    this.setButtonHidden(this.nextButtonTarget, el.scrollLeft >= maxScroll - 1);
  }

  setButtonHidden(button, hidden) {
    button.classList.toggle('hr-organization-nav__btn--hidden', hidden);
    if (hidden) {
      button.setAttribute('aria-hidden', 'true');
    } else {
      button.removeAttribute('aria-hidden');
    }
  }

  scrollActiveIntoView() {
    const el = this.viewportTarget;
    if (el.scrollWidth <= el.clientWidth) return;

    const active = el.querySelector('a.active');
    if (!active) return;

    requestAnimationFrame(() => {
      active.scrollIntoView({ inline: 'center', block: 'nearest', behavior: 'auto' });
      this.updateArrows();
    });
  }
}
